<template>
   <span>{{label}}</span>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import _ from 'lodash';

export default {
    name: "SelectViewComponent",
    components: {vSelect},
    props: {
        urlShow: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            label: '',

        }
    },

    methods: {
        getData() {
            let app = this;
            if (this.model_id !== '') {

                this.$loading(true);
                axios.get(this.urlShow)
                    .then((response) => {
                        app.label = response.data.label
                    })
                    .then(() => {
                        this.$loading(false);
                    });
            }
        },
    },
    mounted() {

        this.getData();
    }


}
</script>

</style>
